import React, { useState, useEffect } from 'react';
import { Trans } from 'react-i18next';
import { NBXReferral } from 'services';
import Signup from 'routes/Signup';
import Heading from 'components/shared/Heading';
import { isNullish } from 'helpers/objects';
import { useRemoteFeatureFlag } from '@nbx/config';
import { setIsEnrollFirebaseSms2faOnSignup, setReferrals } from 'reduxConfig/auth.creators';
import useReferralSearchParam from './useReferralSearchParam';
import usePartnershipSearchParam from './usePartnershipSearchParam';
import styles from './styles.module.scss';

function SignupWrapper({ dispatch, referralCode: referralCodeStored, ...rest }) {
  const referralSearchParam = useReferralSearchParam();
  const partnershipSearchParam = usePartnershipSearchParam();
  const [loading, setLoading] = useState(true);
  const [referrer, setReferrer] = useState(null);
  const [referralCodeValidated, setReferralCodeValidated] = useState(null);
  const [cardPartnershipCode, setCardPartnershipCode] = useState(null);

  const [isEnrollFirebaseSms2faOnSignup, isLoadingFeatureFlag] = useRemoteFeatureFlag(
    'auth_enroll_sms_2fa_on_signup_feature_flag'
  );

  useEffect(() => {
    if (isLoadingFeatureFlag === false) {
      dispatch(setIsEnrollFirebaseSms2faOnSignup(isEnrollFirebaseSms2faOnSignup));
    }
  }, [isLoadingFeatureFlag]);

  useEffect(() => {
    const validateReferralCode = async referralCode => {
      if (referralCode) {
        setLoading(true);
        try {
          const { valid, name } = await NBXReferral.validate(referralCode);
          if (!valid) {
            console.warn('User provided invalid referral code, ignoring');
          } else {
            if (!isNullish(name)) setReferrer(name);
            dispatch(setReferrals({ referralCode }));
            setReferralCodeValidated(referralCode);
          }
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    validateReferralCode(referralSearchParam);
  }, [referralSearchParam]);

  useEffect(() => {
    // eslint-disable-next-line no-console
    if (partnershipSearchParam) setCardPartnershipCode(partnershipSearchParam);
  }, [partnershipSearchParam]);

  return (
    <>
      {!loading && (referralCodeValidated || referralCodeStored) && referrer && (
        <Heading styles={[styles.inviteHeadTitle]} tag="h1">
          <Trans
            i18nKey="auth_signup_invited_by"
            values={{ referrer }}
            defaults="{{referrer}} has invited you to join NBX!"
          />
        </Heading>
      )}
      {!loading && (referralCodeValidated || referralCodeStored) && !referrer && (
        <Heading styles={[styles.inviteHeadTitle]} tag="h1">
          <Trans
            i18nKey="auth_signup_invited_neutral"
            values={{ referrer }}
            defaults="You've been invited to join NBX!"
          />
        </Heading>
      )}
      <Signup
        {...rest}
        dispatch={dispatch}
        isReferralCodeParamValid={(!loading && !isNullish(referralCodeValidated)) || !!referralCodeStored}
        referralCodeParam={referralCodeValidated || referralCodeStored || referralSearchParam}
        cardPartnershipCode={cardPartnershipCode}
        loadingReferral={loading}
        setReferrer={setReferrer}
      />
    </>
  );
}

export default SignupWrapper;
